import { Divider, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import ValueCollected from "./ValueCollected";
import AdvancedFiltersGroupBy from "./AdvancedFiltersGroupBy";
import { useSelector } from "react-redux";
import { getDeepViewLineageEntry } from "../../deepViewFieldMap";

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const StageTwo = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const lineageEntry = getDeepViewLineageEntry(deepViewData, columnKey);

  const details = [
    {
      label: "source field",
      value: lineageEntry?.source_field_expression,
      bold: true,
    },
    { label: "destination field", value: lineageEntry?.field_name },
    { label: "calculation type", value: lineageEntry?.calculation_type_name },
  ];

  return (
    <>
      <Stack mb={1}>
        {details.map((item, index) => (
          <React.Fragment key={item.label}>
            <Typography
              fontSize={12}
              fontWeight={item.bold ? 700 : 400}
              py={0.5}
            >
              <Box
                component="span"
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 400,
                  width: 150,
                  display: "inline-block",
                }}
              >
                {item.label}
              </Box>
              {item.value ?? "-"}
            </Typography>

            {index !== details.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>

      <ValueCollected columnKey={columnKey} />
      <AdvancedFiltersGroupBy columnKey={columnKey} />
    </>
  );
};

export default StageTwo;
